import { render, staticRenderFns } from "./Prontos.vue?vue&type=template&id=2e729720&scoped=true&"
import script from "./Prontos.vue?vue&type=script&lang=js&"
export * from "./Prontos.vue?vue&type=script&lang=js&"
import style0 from "./Prontos.vue?vue&type=style&index=0&id=2e729720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e729720",
  null
  
)

export default component.exports